import store from './store';
import LABEL_CONST from './constants/label';
import CUSTOM_MESSAGES_CONST from '@constants/customMessage';
import { getObjectValue } from '@utility/utills';
import { GET_BRAND_THEME_URL_SUCCESS } from './reducers/theme';

const veriables = type => {
  const newState = store.getState();
  switch (type) {
    case 'LABEL':
      return {
        ...LABEL_CONST,
        ...(getObjectValue(() => newState.theme.variableProperties, {}).label ||
          {}),
        CURRENCY_SYMBOL: '$',
      };
    case 'CUSTOM_MESSAGES':
      return {
        ...CUSTOM_MESSAGES_CONST,
        ...(getObjectValue(() => newState.theme.variableProperties, {})
          .customMessage || {}),
      };
    default:
      return LABEL_CONST;
  }
};
let labelData = veriables('LABEL');
let customMessagesData = veriables('CUSTOM_MESSAGES');
store.subscribe(() => {
  const lastAction = store.getState().lastAction;
  if (lastAction.type === GET_BRAND_THEME_URL_SUCCESS) {
    labelData = veriables('LABEL');
    customMessagesData = veriables('CUSTOM_MESSAGES');
  }
});
export let LABEL = () => labelData;
export const CUSTOM_MESSAGES = () => customMessagesData;
export default veriables;
